/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CollectionIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Collection',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16.75,3H3.25c-1.24023,0-2.25,1.00977-2.25,2.25v9.5c0,1.24023,1.00977,2.25,2.25,2.25h13.5c1.24023,0,2.25-1.00977,2.25-2.25V5.25c0-1.24023-1.00977-2.25-2.25-2.25ZM17.5,5.25v4h-4v-4.75h3.25c.41309,0,.75.33691.75.75ZM8,9.25v-4.75h4v4.75h-4ZM12,10.75v4.75h-4v-4.75h4ZM3.25,4.5h3.25v4.75H2.5v-4c0-.41309.33691-.75.75-.75ZM2.5,14.75v-4h4v4.75h-3.25c-.41309,0-.75-.33691-.75-.75ZM16.75,15.5h-3.25v-4.75h4v4c0,.41309-.33691.75-.75.75Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
